<div class="hd-moon-transit-legend" [attr.data-section]="section()">
  @switch (section()) {
    @case ('channels') {
      <div class="hd-moon-transit-legend__group">
        @for (swatch of typeSwatches; track swatch.labelKey) {
          <span class="hd-moon-transit-legend__item">
            <span class="hd-moon-transit-legend__swatch" [style.background]="swatch.color"></span>
            {{ t(swatch.labelKey) }}
          </span>
        }
      </div>
      <p class="hd-moon-transit-legend__cycle">{{ t('humanDesign.chart.moonTransit.legend.cycle') }}</p>
    }
    @case ('symbols') {
      <div class="hd-moon-transit-legend__group">
        <span class="hd-moon-transit-legend__item">
          <span class="hd-moon-transit-legend__ring-sample" aria-hidden="true"></span>
          {{ t('humanDesign.chart.moonTransit.legend.ring') }}
        </span>
        <span class="hd-moon-transit-legend__item">
          <span class="hd-moon-transit-legend__arrows" aria-hidden="true">▲▼</span>
          {{ t('humanDesign.chart.moonTransit.legend.fixation') }}
        </span>
        <span class="hd-moon-transit-legend__item">
          <i eIcon icon="bridge" class="hd-moon-transit-legend__bridge" aria-hidden="true"></i>
          {{ t('humanDesign.chart.moonTransit.legend.bridge') }}
        </span>
        <span class="hd-moon-transit-legend__item">
          <span class="hd-moon-transit-legend__today-icon" aria-hidden="true">{{ moonGlyph }}</span>
          {{ t('humanDesign.chart.moonTransit.legend.today') }}
        </span>
      </div>
    }
  }
</div>
